import { render, staticRenderFns } from "./card3.md?vue&type=template&id=48a7eb6e&"
import script from "./card3.md?vue&type=script&lang=js&"
export * from "./card3.md?vue&type=script&lang=js&"
import style0 from "./card3.md?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports